module.exports = __webpack_public_path__ + "hyperion-v2-static/img/cr_logo_white_bg.b424761a.png";